import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import SvgIcon from "@mui/material/SvgIcon";
import EditIcon from '@mui/icons-material/Edit';
import ShareIcon from '@mui/icons-material/Share';
import AssignmentIcon from "@mui/icons-material/Assignment";
import ReplayIcon from "@mui/icons-material/Replay";

import {LookIntroIcon, LookLayoutIcon, LookRoomIdeasIcon} from "../../../common/icons";
import COLOR_THEMES from "../../../../colorThemes";
import {LOOK_INTRO_STEPS} from "../../core/constants";
import {MaterialPhotoPrintsIcon} from "../../../common/svgIcons/materialIcons";
// import BathroomFeatureGroupsIcons from "../../../common/svgIcons/bathroomFeatureGroupIcons";


const LookIntroBoxIcon = (props) => {

  const {introStep, isMobile, activeTheme, showRoomLayoutsButton} = props;

  switch (introStep) {
    case LOOK_INTRO_STEPS.welcome:
    default:
      return (
        <SvgIcon style={{ fontSize: 22 }}>
          <LookIntroIcon/>
        </SvgIcon>
      )
    case LOOK_INTRO_STEPS.wallsAndFloor:
      return <EditIcon/>
    case LOOK_INTRO_STEPS.aiStep:
      return MaterialPhotoPrintsIcon
    // case 2:
    //   return (
    //     <SvgIcon>
    //       {BathroomFeatureGroupsIcons["shower_wall"]}
    //     </SvgIcon>
    //   )
    case LOOK_INTRO_STEPS.layouts:
      if (!showRoomLayoutsButton && isMobile) {
        return (
          <SvgIcon>
            <ReplayIcon/>
          </SvgIcon>
        )
      }
      return (
        <SvgIcon>
          <LookLayoutIcon/>
        </SvgIcon>
      )
    case LOOK_INTRO_STEPS.layoutsAndRooms:
      return (
        <SvgIcon>
          <LookLayoutIcon/>
        </SvgIcon>
      )
    case LOOK_INTRO_STEPS.saveAndMore:
      return <ShareIcon/>
    case LOOK_INTRO_STEPS.rooms:
      return (
        <SvgIcon>
          <LookRoomIdeasIcon color={COLOR_THEMES[activeTheme].primary} />
        </SvgIcon>
      )
    case LOOK_INTRO_STEPS.review:
      return <AssignmentIcon/>
  }

};

LookIntroBoxIcon.propTypes = {
  showRoomLayoutsButton: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {introStep} = store.lookState;
  const {isMobile, activeTheme} = store.serverState;
  return {
    introStep,
    isMobile,
    activeTheme,
  };
};

export default connect(mapStateToProps)(LookIntroBoxIcon)
